import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { galleryImages as defaultImages } from '../data/mock';
import { publicApi } from '../lib/api';

const Gallery = () => {
  const [images, setImages] = useState(defaultImages);

  useEffect(() => {
    publicApi.get('/photos').then((r) => {
      const uploaded = (r.data || []).map((p) => ({ url: p.data_url, alt: p.caption || 'Treatment photo' }));
      setImages([...uploaded, ...defaultImages]);
    }).catch(() => {});
  }, []);

  const items = [...images, ...images];

  return (
    <section id="gallery" className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <p className="text-white/80 tracking-[0.3em] text-xs md:text-sm font-light mb-4" style={{ fontFamily: "'Josefin Sans', sans-serif" }}>
            GALLERY
          </p>
          <h2 className="text-white font-light" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2rem, 4.5vw, 3.5rem)' }}>
            A little taste of bliss
          </h2>
          <div className="mt-6 mx-auto w-24 h-px bg-white/50" />
        </motion.div>
      </div>

      <div className="relative">
        <div className="marquee flex gap-6 w-max">
          {items.map((img, idx) => (
            <div key={idx} className="relative w-[260px] md:w-[340px] h-[340px] md:h-[420px] flex-shrink-0 rounded-3xl overflow-hidden shadow-xl group">
              <img src={img.url} alt={img.alt} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .marquee { animation: marquee-scroll 60s linear infinite; }
        .marquee:hover { animation-play-state: paused; }
      `}</style>
    </section>
  );
};

export default Gallery;
